<template>
    <div class="story-maker-sticker story-maker-sticker-link-facebook" @click="openEditMenu">
        <div class="link-pill">
            <i class="fa-solid fa-link"></i>
            <span>{{ pillText }}</span>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import { facebookLinkButtonTypeLabels } from '../../facebookLinkButtonTypes.js'

export default {
    props: {
        id: [Number, String],
        link: String,
        mode: String,
        buttonType: String,
    },

    methods: {
        openEditMenu() {
            EventBus.$emit('storyMaker-setOverlay', 'stickers-linkMenu', {
                id: this.id,
                link: this.link,
                mode: this.mode,
                buttonType: this.buttonType,
            })
        },
    },

    computed: {
        pillText() {
            if (this.mode === 'shop') return this.$t('dash.post-creator.story.link-button-shop-preview-text')
            return facebookLinkButtonTypeLabels(this.$t.bind(this))[this.buttonType] || this.link
        },
    },
}
</script>
